import { useEffect, useRef, useMemo } from "react";
import { uiAlert } from "../components/alerts/customAlert/uiAlert";

export function useIdelHandler(onIdle, idleMs = 60 * 60 * 1000) {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const timer = useRef(null);
  const events = ["pointermove", "keydown", "pointerdown"];
  // Reset the inactivity timer
  const lastActivity = useRef(Date.now());
  const resetTimer = () => {
    // check if current time is pass midnight since last interaction

    try {
      let ismidnightCrossed = hasCrossedMidnight(Number(localStorage.getItem("lastInteractionAt")) || lastActivity.current);
      if (ismidnightCrossed && handleMidnightExpiry()) {
        uiAlert("Session expired due to inactivity, please log in again.");
        localStorage.setItem("lastInteractionAt", Date.now().toString());
        onIdle();
        return;
      } else {
        console.log("midnight not crossed", lastActivity.current, Date.now());
      }

      clearTimeout(timer.current);
      timer.current = setTimeout(onIdle, idleMs);
      //set last interaction time on local storage
      lastActivity.current = Date.now();
      localStorage.setItem("lastInteractionAt", Date.now().toString());
    } catch (error) {
      console.log(error);
    }
  };

  function throttle(fn, delay) {
    let lastCall = 0;
    return (...args) => {
      const now = Date.now();
      if (now - lastCall >= delay) {
        lastCall = now;
        fn(...args);
      }
    };
  }
  const throttledResetTimer = useMemo(() => throttle(resetTimer, 1000 * 60 * 60), []);

  useEffect(() => {
    // Attach event listeners
    events.forEach((evt) => window.addEventListener(evt, throttledResetTimer, { passive: true }));
    // Start the initial timer
    throttledResetTimer();

    // Handle visibility change
    const visibilityChangeHandler = () => {
      if (document.visibilityState === "visible") {
        throttledResetTimer();
      }
    };

    // For mobile devices, to visibility change
    document.addEventListener("visibilitychange", visibilityChangeHandler, { passive: true });

    return () => {
      // Cleanup
      clearTimeout(timer.current);
      events.forEach((evt) => window.removeEventListener(evt, throttledResetTimer, { passive: true }));

      document.removeEventListener("visibilitychange", visibilityChangeHandler, { passive: true });
    };
  }, []);
}

// 1) Has the date rolled over since a stored timestamp?
export function hasCrossedMidnight(lastTs) {
  const d1 = new Date(lastTs);
  const d2 = new Date();
  d1.setHours(0, 0, 0, 0);
  d2.setHours(0, 0, 0, 0);
  return d1.getTime() !== d2.getTime();
}

function handleMidnightExpiry() {
  const key = "idleExpiryHandledAt";

  // value is the date that last midnight was handled, e.g. "2025-01-19"
  const lastHandledDate = localStorage.getItem(key);

  const today = new Date().toISOString().slice(0, 10); // e.g. "2025-01-19"

  if (lastHandledDate === today) {
    // already handled today
    return false;
  }

  // first time handling midnight today
  localStorage.setItem(key, today);
  return true;
}
